import router from '../../helpers/router';
import { agreementService } from '../../services';

// initial state
const state = {
    list: [],
    status: [],
};

// getters
const getters = {};

// actions
const actions = {
    list ({ dispatch, commit }, data) {
        return agreementService
            .list(data)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    update ({ dispatch, commit }, { id, data }) {
        commit('updateRequest');

        return agreementService
            .update(id, data)
            .then(() => {
                commit('updateSuccess');
                dispatch('alert/success', { message: 'Overeenkomst is gewijzigd' }, { root: true }).then(() => {
                    router.push('/admin/account');
                });
            })
            .catch((error) => {
                commit('updateFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    pdf ({ dispatch }, id) {
        return agreementService
            .pdf(id)
            .then((data) => data)
            .catch((error) => {
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setList (state, nodes) {
        state.list = nodes;
    },

    // update
    updateRequest (state) {
        state.status = { updating: true };
    },
    updateSuccess (state) {
        state.status = { updated: true };
    },
    updateFailure (state) {
        state.status = {};
    },

    // pdf
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
